module.exports = __webpack_public_path__ + "c05806ecf16d18d6b2343d1478888cfb.svg";